import { SupportedLanguage } from "./languages";

export const APP_STORE_URLS: Record<SupportedLanguage, string> = {
  en: "https://apps.apple.com/us/app/public-speaking-coach-babli/id6746377369",
  es: "https://apps.apple.com/mx/app/hablar-en-p%C3%BAblico-ia-babli/id6746377369",
  fr: "https://apps.apple.com/fr/app/parler-en-public-ia-babli/id6746377369",
  de: "https://apps.apple.com/de/app/rhetorik-sprechcoach-babli/id6746377369",
};

export const APP_NAMES: Record<SupportedLanguage, string> = {
  en: "Public Speaking Coach: Babli",
  es: "Hablar en Público IA: Babli",
  fr: "Parler en public IA: Babli",
  de: "Rhetorik & Sprechcoach: Babli",
};

export const APP_SUBTITLES: Record<SupportedLanguage, string> = {
  en: "Public Speaking Practice",
  es: "Practica Oratoria y Discurso",
  fr: "Discours, Prise de parole",
  de: "Besser vor Publikum sprechen",
};

export const getAppStoreUrl = (language: SupportedLanguage): string =>
  APP_STORE_URLS[language];
